import {
  getObject,
} from "@surya-digital/leo-ts-types";
import { GridOpenEndedQuestionV1, GridOpenEndedQuestionV1DTO } from "./gridOpenEndedQuestionV1";
import { GridSingleChoiceQuestionV1, GridSingleChoiceQuestionV1DTO } from "./gridSingleChoiceQuestionV1";
import { GridMultiChoiceQuestionV1, GridMultiChoiceQuestionV1DTO } from "./gridMultiChoiceQuestionV1";


export namespace GridColumnQuestionTypeV1 {
  export interface OpenEndedDTO {
    case: string;
    openEndedQuestionAttributes: GridOpenEndedQuestionV1DTO;
  }
  
  export class OpenEnded {
    readonly isGridColumnQuestionTypeV1OpenEnded: boolean = true;
  
    readonly openEndedQuestionAttributes: GridOpenEndedQuestionV1;
  
  
    constructor(
    openEndedQuestionAttributes: GridOpenEndedQuestionV1
    ) {
      this.openEndedQuestionAttributes = openEndedQuestionAttributes;
    }
  
    static fromDTO(dto: OpenEndedDTO): OpenEnded {
      const openEndedQuestionAttributes = GridOpenEndedQuestionV1.fromDTO(getObject(dto, "openEndedQuestionAttributes", InvalidGridColumnQuestionTypeV1OpenEndedOpenEndedQuestionAttributesError));
      return new OpenEnded(
        openEndedQuestionAttributes
      );
    }
  
    toDTO(): OpenEndedDTO {
      const dto: OpenEndedDTO = {
        case: "OPEN_ENDED",
          openEndedQuestionAttributes: this.openEndedQuestionAttributes.toDTO()
      };
      return dto;
    }
    }
  
  OpenEnded.prototype.toString = function toString(): string {
    return `GridColumnQuestionTypeV1.OPEN_ENDED(openEndedQuestionAttributes='${this.openEndedQuestionAttributes}')`;
  };
  
  export interface SingleChoiceDTO {
    case: string;
    singleChoiceQuestionAttributes: GridSingleChoiceQuestionV1DTO;
  }
  
  export class SingleChoice {
    readonly isGridColumnQuestionTypeV1SingleChoice: boolean = true;
  
    readonly singleChoiceQuestionAttributes: GridSingleChoiceQuestionV1;
  
  
    constructor(
    singleChoiceQuestionAttributes: GridSingleChoiceQuestionV1
    ) {
      this.singleChoiceQuestionAttributes = singleChoiceQuestionAttributes;
    }
  
    static fromDTO(dto: SingleChoiceDTO): SingleChoice {
      const singleChoiceQuestionAttributes = GridSingleChoiceQuestionV1.fromDTO(getObject(dto, "singleChoiceQuestionAttributes", InvalidGridColumnQuestionTypeV1SingleChoiceSingleChoiceQuestionAttributesError));
      return new SingleChoice(
        singleChoiceQuestionAttributes
      );
    }
  
    toDTO(): SingleChoiceDTO {
      const dto: SingleChoiceDTO = {
        case: "SINGLE_CHOICE",
          singleChoiceQuestionAttributes: this.singleChoiceQuestionAttributes.toDTO()
      };
      return dto;
    }
    }
  
  SingleChoice.prototype.toString = function toString(): string {
    return `GridColumnQuestionTypeV1.SINGLE_CHOICE(singleChoiceQuestionAttributes='${this.singleChoiceQuestionAttributes}')`;
  };
  
  export interface MultiChoiceDTO {
    case: string;
    multiChoiceQuestionAttributes: GridMultiChoiceQuestionV1DTO;
  }
  
  export class MultiChoice {
    readonly isGridColumnQuestionTypeV1MultiChoice: boolean = true;
  
    readonly multiChoiceQuestionAttributes: GridMultiChoiceQuestionV1;
  
  
    constructor(
    multiChoiceQuestionAttributes: GridMultiChoiceQuestionV1
    ) {
      this.multiChoiceQuestionAttributes = multiChoiceQuestionAttributes;
    }
  
    static fromDTO(dto: MultiChoiceDTO): MultiChoice {
      const multiChoiceQuestionAttributes = GridMultiChoiceQuestionV1.fromDTO(getObject(dto, "multiChoiceQuestionAttributes", InvalidGridColumnQuestionTypeV1MultiChoiceMultiChoiceQuestionAttributesError));
      return new MultiChoice(
        multiChoiceQuestionAttributes
      );
    }
  
    toDTO(): MultiChoiceDTO {
      const dto: MultiChoiceDTO = {
        case: "MULTI_CHOICE",
          multiChoiceQuestionAttributes: this.multiChoiceQuestionAttributes.toDTO()
      };
      return dto;
    }
    }
  
  MultiChoice.prototype.toString = function toString(): string {
    return `GridColumnQuestionTypeV1.MULTI_CHOICE(multiChoiceQuestionAttributes='${this.multiChoiceQuestionAttributes}')`;
  };
  

  export type GridColumnQuestionTypeV1 = OpenEnded | SingleChoice | MultiChoice;

  export type GridColumnQuestionTypeV1DTO = OpenEndedDTO | SingleChoiceDTO | MultiChoiceDTO;

  export const fromDTO = (dto: GridColumnQuestionTypeV1DTO): GridColumnQuestionTypeV1 => {
    switch (dto.case) {
      case "OPEN_ENDED":
          return OpenEnded.fromDTO(dto as OpenEndedDTO);
      case "SINGLE_CHOICE":
          return SingleChoice.fromDTO(dto as SingleChoiceDTO);
      case "MULTI_CHOICE":
          return MultiChoice.fromDTO(dto as MultiChoiceDTO);
      default:
        throw new InvalidGridColumnQuestionTypeV1Error(
            `Case ${dto.case} is not valid case of GridColumnQuestionTypeV1.`
        );
    }
  };
}

export class InvalidGridColumnQuestionTypeV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridColumnQuestionTypeV1Error";
  }
}
export class InvalidGridColumnQuestionTypeV1OpenEndedError extends InvalidGridColumnQuestionTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridColumnQuestionTypeV1OpenEndedError";
  }
}

export class InvalidGridColumnQuestionTypeV1OpenEndedOpenEndedQuestionAttributesError extends InvalidGridColumnQuestionTypeV1OpenEndedError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridColumnQuestionTypeV1OpenEndedOpenEndedQuestionAttributesError";
  }
}

export class InvalidGridColumnQuestionTypeV1SingleChoiceError extends InvalidGridColumnQuestionTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridColumnQuestionTypeV1SingleChoiceError";
  }
}

export class InvalidGridColumnQuestionTypeV1SingleChoiceSingleChoiceQuestionAttributesError extends InvalidGridColumnQuestionTypeV1SingleChoiceError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridColumnQuestionTypeV1SingleChoiceSingleChoiceQuestionAttributesError";
  }
}

export class InvalidGridColumnQuestionTypeV1MultiChoiceError extends InvalidGridColumnQuestionTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridColumnQuestionTypeV1MultiChoiceError";
  }
}

export class InvalidGridColumnQuestionTypeV1MultiChoiceMultiChoiceQuestionAttributesError extends InvalidGridColumnQuestionTypeV1MultiChoiceError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridColumnQuestionTypeV1MultiChoiceMultiChoiceQuestionAttributesError";
  }
}
